import React from "react";
import { Typography, Grid, Box, Paper, Button } from "@mui/material";
import "./complains.css";

const Complains = ({ nextStep, prevStep }) => {
  // Array of complaints steps
  const complaintsData = [
    {
      number: "./CYPImages/numbers/1.png",
      text: "You should always begin by letting your keyworker or another adult in the home know what is wrong and they will try and help you.",
      bgColor: "#FFE4E8",
      colour: "#FF8FA0",
    },
    {
      number: "./CYPImages/numbers/2.png",
      text: "If you feel they need help they will speak to the manager or your social worker.",
      bgColor: "#F5F3E1",
      colour: "#CFBF29",
    },
    {
      number: "./CYPImages/numbers/3.png",
      text: "If you tell an adult something which is serious they will have to pass the information on to other adults that need to know to make sure you are kept safe.",
      bgColor: "#DAD0DC",
      colour: "#A44EB5",
    },
    {
      number: "./CYPImages/numbers/4.png",
      text: "Adults at Little Norway will not keep secrets.",
      bgColor: "#DFEDE2",
      colour: "#2B9D43",
    },
    {
      number: "./CYPImages/numbers/5.png",
      text: "If you feel you cannot share your problem with one of the adults or your keyworker you can speak to the Manager or call your social worker.",
      bgColor: "#F9E4DF",
      colour: "#BB5D46",
    },
    {
      number: "./CYPImages/numbers/6.png",
      text: "If you are still worried or unhappy you can speak to ............ who is the responsible individual.",
      bgColor: "#ECECEC",
      colour: "#80645D",
    },
    {
      number: "./CYPImages/numbers/7.png",
      text: "There are other people you can contact if you wish to make a complaint, their numbers are at the end of this guide.",
      bgColor: "#FFEAFF",
      colour: "#EA6DEA",
    },
  ];

  return (
    <Box className='complaints-container'>
      <Box className='left-flower-character'>
        <img src='./CYPImages/WormisRainbow.png' alt='left-flower character' className='left-flower-character-image' />
      </Box>
      <Box className='complaints-form-container'>
        {/* Title */}
        <Typography variant='h4' className='complains-title' align='center' gutterBottom>
          Complains
        </Typography>

        {/* Complaint Steps */}
        <Grid container spacing={2} justifyContent='center'>
          {complaintsData.map((item, index) => (
            <Grid item xs={12} key={index}>
              <Paper className='complaint-step' style={{ backgroundColor: item.bgColor }} elevation={3}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  {/* Step Number */}
                  <Box className='step-number'>
                    <Typography align='center'>
                      <img src={item.number} alt='' width={"50px"} height={"70px"} />
                    </Typography>
                  </Box>

                  {/* Step Text */}
                  <Typography variant='body1' className='step-text' style={{ color: item.colour }} ml={1}>
                    {item.text}
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
        <Grid container justifyContent='space-between' alignItems='center' mt={2}>
          <Grid item>
            <Button type='button' variant='contained' color='primary' onClick={prevStep}>
              Previous
            </Button>
          </Grid>
          <Grid item>
            <Button type='button' variant='contained' color='primary' onClick={nextStep}>
              Next
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Box className='bottom-forms' mr={3}>
        <img src='./CYPImages/WormisOutdoors.png' alt='Bottom Character' className='bottom-forms-image' />
      </Box>
    </Box>
  );
};

export default Complains;
